export { default as CommonHeader } from './CommonHeader'
export { default as CommonFooter } from './CommonFooter'
export { default as MockHeader } from './MockHeader'
export { default as CommonTips } from './CommonTips'
export { default as CommonBreadcrumb } from './CommonBreadcrumb'
export { default as CommonNewHeader } from './CommonNewHeader'
